/**
 * Datetime helpers scoped to Caring (Portugal / Europe/Lisbon).
 *
 * All internal scheduling values (RT date, follow-up retry, etc.) are
 * intended to be stored as *naive local Portugal time* — ``YYYY-MM-DDTHH:MM``
 * without any timezone suffix. Historically a few flows appended ``Z`` or
 * ``+00:00``, which caused ``new Date(iso)`` to be interpreted as UTC and
 * shifted +1h when rendered in WEST (Portugal summer time).
 *
 * ``parseLocalIso`` strips any trailing timezone marker so both old rows
 * and new rows render at the intended local hour without needing a data
 * migration. Use this everywhere you would otherwise call
 * ``new Date(scheduled_qt_at)`` / ``new Date(fu.scheduled_for)``.
 */
export function parseLocalIso(iso) {
  if (!iso || typeof iso !== "string") return null;
  const stripped = iso.replace(/(Z|[+-]\d{2}:?\d{2})$/, "");
  const dt = new Date(stripped);
  return isNaN(dt.getTime()) ? null : dt;
}
